import React from 'react';
import { Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Footer from './Footer.js';

function TodoAppPrivacyPolicy() {
  return (
    <>
      <div
        style={{ marginLeft: '10px', marginTop: '50px' }}
        className="Black_char"
      >
        <Typography gutterBottom variant="h4">
          Todoリスト プライバシーポリシー
        </Typography>
        <Typography gutterBottom variant="h7">
          プライバシーの最終更新日：2023年7月30日
        </Typography>
        <List
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <AnchorLink href="#todo_privacy_policy_item1" className="list_item">
            <ListItemButton>
              <ListItemText primary="1.個人情報の収集" />
            </ListItemButton>
          </AnchorLink>
          <AnchorLink href="#todo_privacy_policy_item2" className="list_item">
            <ListItemButton>
              <ListItemText primary="2.データの保存とセキュリティ" />
            </ListItemButton>
          </AnchorLink>
          <AnchorLink href="#todo_privacy_policy_item3" className="list_item">
            <ListItemButton>
              <ListItemText primary="3.Cookieの使用" />
            </ListItemButton>
          </AnchorLink>
          <AnchorLink href="#todo_privacy_policy_item4" className="list_item">
            <ListItemButton>
              <ListItemText primary="4.サードパーティとの情報共有" />
            </ListItemButton>
          </AnchorLink>
          <AnchorLink href="#todo_privacy_policy_item5" className="list_item">
            <ListItemButton>
              <ListItemText primary="5.プライバシーポリシーの変更" />
            </ListItemButton>
          </AnchorLink>
          <AnchorLink href="#todo_privacy_policy_item6" className="list_item">
            <ListItemButton>
              <ListItemText primary="6.お問い合わせ" />
            </ListItemButton>
          </AnchorLink>
        </List>

        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item1">
          1.個人情報の収集
        </Typography>
        <Typography gutterBottom variant="body1">
          Kei-no-suke(以下「当方」といいます。)は、
          Todoリスト(以下「本アプリ」といいます。)を提供するにあたって、
          利用者から個人情報の収集を行いません。本アプリは、
          タスクの管理およびToDoリストの作成を支援するだけであり、
          当方が利用者に関連する個人情報を要求することはありません。
        </Typography>
        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item2">
          2.データの保存とセキュリティ
        </Typography>
        <Typography gutterBottom variant="body1">
          本アプリは、利用者の個人情報を収集しないため、
          利用者のデータはサーバーに保存されることはありません。
          全てのタスク、ToDoリストは利用者のデバイス内にローカルに保存されます。したがって、
          当方は本アプリに関して利用者データのセキュリティを確保するための
          サーバーインフラストラクチャを持っていません。
        </Typography>
        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item3">
          3.Cookieの使用
        </Typography>
        <Typography gutterBottom variant="body1">
          当方は、本アプリを提供するにあたって、利用者から個人情報の収集を行いません。本アプリは、
          タスクの管理およびToDoリストの作成を支援するだけであり、
          利用者に関連する個人情報を要求することはありません。
        </Typography>
        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item4">
          4.サードパーティとの情報共有
        </Typography>
        <Typography
          gutterBottom
          variant="body1"
          className="privacyPolicyHeader"
        >
          本アプリは、利用者の個人情報をサードパーティと共有しません。
          また、広告や分析目的で利用者データを収集するために外部サービスを
          使用することもありません。
        </Typography>
        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item5">
          5.プライバシーポリシーの変更
        </Typography>
        <Typography
          gutterBottom
          variant="body1"
          className="privacyPolicyHeader"
        >
          当方は、本アプリに関して、プライバシーポリシーを変更する場合があります。
          修正された最新のプライバシーポリシーは常に本ページにて開示されます。
        </Typography>
        <Typography gutterBottom variant="h5" id="todo_privacy_policy_item6">
          6.お問い合わせ
        </Typography>
        <Typography gutterBottom variant="body1">
          本アプリに関するプライバシーポリシーについてご質問やお問い合わせがある場合は、
          以下の連絡先までお願いいたします。
        </Typography>
        <Typography gutterBottom variant="body1">
          [連絡先]
          <br />
          k08757911@gmail.com
        </Typography>
        <Typography gutterBottom variant="body1">
          以上が、本アプリのプライバシーポリシーです。
          お客様のプライバシーを尊重し、個人情報を収集せず、
          セキュリティに最大限の配慮を行っています。
          何かご不明点がございましたら、いつでもお問い合わせください。
        </Typography>
      </div>
      <div style={{ marginLeft: '10px', marginBottom: '80px' }}></div>
      <Footer />
    </>
  );
}

export default TodoAppPrivacyPolicy;
